module.exports = __webpack_public_path__ + "961b2ac3217af9e20c7d2b0eab9e6eb6.svg";